import styled from 'styled-components'
import { BidRulesModalCSS } from './BidRulesModalCSS.styled'
import { icons } from 'common'

export const BidRulesModal = ({ closeModal }) => {
  return (
    <BidRulesModalCSS>
      <div className='popUpContainer fees_calc width-500'>
        <article>
          <CloseWindowIcon onClick={() => closeModal()} />

          <h1>Bidding Rules</h1>

          <div className='fees_on_profit_wrap'>
            <div className='subtitle'>BIDDING WITH SYNTHETIC STOCKS</div>
            <ul>
              <li>Orders on synthetic stocks can only be placed only during market hours.</li>
              <li>
                All synthetic stock orders with leverage more than 10x will automatically get closed at the end of
                market hours on the same day.
              </li>
              {/* <li>
                All synthetic stock orders left open at the end of the day’s market hours will incur rollover fees.
              </li> */}
              <li>
                Synthetic stock orders can only be closed during market hours, which also applies to your Take Profit
                and Stop Loss triggers, if applicable.
              </li>
            </ul>
            <div className='subtitle'>SPAM</div>
            <p>
              Spamming our Bids table will leave you exiled from the YOLOREKT community, sent off to fend on your own.
              Here are some rules and guidelines that we’d like you abide by, or you’ll be banned…
            </p>
            <ul>
              <li>
                Microbids are encouraged and welcomed. However, we strongly encourage placing less than 5 in-a-row to
                test whatever strategy you’re trying out.
              </li>
              <li>
                Any bidding that abuses the microbidding privilege (by placing 6+ microbids in a row), any actions that
                impact the general usage of the product, and/or degrade the user experience where discovering bid
                direction trends is crucial, is strongly discouraged and will be considered spam.
              </li>
              <li>Creating and using multiple YOLOREKT accounts to place bids is strictly prohibited.</li>
            </ul>
          </div>
        </article>
      </div>
    </BidRulesModalCSS>
  )
}

const CloseWindowIcon = styled.div`
  top: -5px;
  left: -5px;
  -webkit-mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
  mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
  background: hsl(0, 0%, 100%);
  width: 22px;
  height: 22px;
  display: block;
  position: absolute;
  color: #fff;
  text-decoration: none;
  text-decoration-color: rgba(255, 255, 255, 0.4);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  z-index: 2;
  cursor: pointer;

  &:hover {
    background: #c0392b;
  }
`
